import { StyleSheet } from 'react-native';
import { brand } from 'src/theme/colors';
import { COLOR_TOOL_PALETTE } from './ColorToolOption.constants';
import { FOCUS_COLOR } from 'src/theme-v2/focus';

export const styles = StyleSheet.create({
  circularColorWrapper: {
    borderWidth: 2,
    borderColor: 'transparent',
    borderRadius: 100,
    padding: 5,
  },
  circularColorWrapperActive: {
    borderColor: brand.main.water,
  },
  circularColorWrapperDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  circularColor: {
    borderRadius: 100,
    width: 52,
    height: 52,
  },
  textColor: {
    fontWeight: 400,
    fontSize: 14,
    marginBottom: 4,
  },
  textColorActive: {
    fontWeight: 700,
  },
  textColorDisabled: {
    opacity: 0.6,
  },
  button: {
    borderWidth: 2,
    borderColor: 'transparent',
  },
  buttonInner: {
    alignItems: 'center',
    gap: 8,
  },
  buttonActive: {
    borderColor: brand.main.water,
  },
  buttonFocus: {
    borderColor: FOCUS_COLOR,
  },
});

const PaletteStyle: Record<string, any> = Object.values(COLOR_TOOL_PALETTE).reduce((acc, color) => {
  return {
    ...acc,
    [color]: {
      backgroundColor: color,
    },
  };
}, {});

PaletteStyle[COLOR_TOOL_PALETTE.white] = {
  ...PaletteStyle[COLOR_TOOL_PALETTE.white],
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: '#e3e3e3ff',
};

export const ColorToolPaletteStyle = PaletteStyle;
